import type { ReactNode } from "react";

import { HERO_CANVAS_BLEED_PX } from "@hero-app/lib/hero-canvas-bleed";
import { cn } from "@hero-app/lib/utils";

const HERO_CANVAS_PRODUCT_FRAME_CLASS =
  "flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-lg border-[0.5px] border-[#E3E6E8] bg-[rgba(255,255,255,0.1)] shadow-[0px_1.241px_18.244px_0px_rgba(0,0,0,0.03)] backdrop-blur-[100px]";

export function HeroCanvasBleedShell({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn("flex min-h-0 flex-1 flex-col bg-transparent", className)}
      style={{ padding: HERO_CANVAS_BLEED_PX }}
      data-hero-canvas-bleed-root
    >
      <div className={HERO_CANVAS_PRODUCT_FRAME_CLASS}>{children}</div>
    </div>
  );
}
